import React, { useEffect } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';

import { CardWrapper } from '@monorepo/common';

import { IEventsStepProps } from '../../interfaces';
import { ArrowRight as ArrowRightIcon } from '../../../../components/Icons/arrow-right';
import { IStep6Form } from './formInterfaces';

interface IStep6Props extends IEventsStepProps {
  defaultData: IStep6Form;
  finalRequest: () => void;
  saveRequest?: () => void;
  isEdited: boolean;
}

export const Step6 = ({
  onBack,
  Nav,
  onComplete,
  defaultData,
  finalRequest,
  saveRequest,
  isEdited,
}:IStep6Props) => {
  const onSubmit = () => {
    if (defaultData?.terms) {
      finalRequest();
    }
  };

  useEffect(() => {
    if (isEdited && onComplete) {
      onComplete();
    }
  }, [isEdited]);

  return (
    <div data-cy="step6">
      <CardWrapper>
        <div style={{ maxHeight: 500, overflowY: 'auto' }}>
          <Typography
            whiteSpace="break-spaces"
            variant="subtitle1"
          >
            {defaultData.terms}
          </Typography>
        </div>
      </CardWrapper>

      <Nav
        nextDisabled={false}
        onBack={onBack}
        nextButton={(
          <Stack
            className="cpg-edit-step-actions"
            direction={{ xs: 'column', sm: 'row' }}
          >
            <Button
              startIcon={<SaveIcon />}
              variant="outlined"
              onClick={saveRequest}
              data-cy="saveListing"
            >
              Save Listing
            </Button>
            <Button
              endIcon={(<ArrowRightIcon fontSize="small" />)}
              variant="contained"
              onClick={onSubmit}
              data-cy="acceptTermsAndContinue"
            >
              Accept Terms and Continue
            </Button>
          </Stack>
                )}
      />
    </div>
  );
};
